export enum FontFamily {
  ARIAL = 'ARIAL',
  BITSTREAM_VERA_SANS_MONO = 'BITSTREAM_VERA_SANS_MONO',
  VERDANA = 'VERDANA',
  COURIER = 'COURIER',
  TIMES = 'TIMES'
}
